import { render, staticRenderFns } from "./OptionGroupField.vue?vue&type=template&id=6a72b9c7&scoped=true&"
import script from "./OptionGroupField.vue?vue&type=script&lang=js&"
export * from "./OptionGroupField.vue?vue&type=script&lang=js&"
import style0 from "./OptionGroupField.vue?vue&type=style&index=0&id=6a72b9c7&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a72b9c7",
  null
  
)

export default component.exports